<template>
  <div>
    <div class="modal-title">{{ $t('tour_new_place_title') }}</div>
    <div class="modal-content">
      <p class="text-xs text-label">{{ $t('tour_genre_label') }}</p>
      <select v-model="genreId" class="modal-select">
        <option v-for="genre in genres" v-bind:key="genre.id" v-bind:value="genre.id">
          {{ genre.name }}
        </option>
      </select>
      <p class="mt-4 text-label text-xs">{{ $t('tour_destination_label') }}</p>
      <select v-model="placeId" class="modal-select">
        <option v-for="place in places" v-bind:key="place.id" v-bind:value="place.id">
          {{ place.name }} &nbsp; ({{$t('tour_about_label')}}{{ place.distance }}km)
        </option>
      </select>
      <div v-if="this.isStay">
        <p class="mt-4 text-label text-xs">{{ $t('tour_checkin_label') }}</p>
        <checkin-time-select v-model="checkinTime" />
        <p class="mt-4 text-label text-xs">{{ $t('tour_checkout_label') }}</p>
        <checkout-time-select v-model="checkoutTime" />
      </div>
      <div v-else>
        <p class="mt-4 text-label text-xs">{{ $t('tour_residence_time_label') }}</p>
        <time-select v-model="time" />
      </div>
    </div>
    <div class="modal-button">
      <a class="button-primary block" @click="handleClick">{{ $t('tour_add') }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TimeSelect from "./TimeSelect"
import CheckoutTimeSelect from "./CheckoutTimeSelect"
import CheckinTimeSelect from "./CheckinTimeSelect"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    TimeSelect,
    CheckoutTimeSelect,
    CheckinTimeSelect
  },
  props: {
    target: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      genreId: undefined,
      placeId: undefined,
      time: 60,
      places: [],
      timeOptions: [],
      isStay: false,
      checkinTime: undefined,
      checkoutTime: undefined
    }
  },
  created: function () {
    let startTime = this.$store.getters['condition/getTime']
    // デフォルトのチェックイン／アウト時間は18:00／10:00
    this.checkinTime = moment(startTime).set('hour', 18)
    this.checkoutTime = moment(startTime).add(1, 'days').set('hour', 10)
    // 出発地から施設を取得し直す
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('places/fetchPlaceLocation', this.target.route.points[0].location)
      .then(() => {
        this.$store.dispatch('genres/fetchAll')
          .then(() => {
            if (this.genres.length > 0) {
              this.genreId = this.genres[0].id
            }
            this.$store.dispatch('loading/endLoading')
          })
      })
  },
  computed: {
    ...mapGetters({
      genres: 'genres/getAllWithoutEmpty'
    })
  },
  methods: {
    handleClick: function () {
      const place = this.$store.getters['places/getPlace'](this.placeId)
      if (place.genreIds.indexOf('TH6_tag159') != -1) {
        const visitTime = this.checkoutTime.diff(this.checkinTime, 'minutes', false)
        this.time = visitTime
        this.$store.dispatch('condition/updateTime', this.checkinTime)
      }
      this.callback(this.target.route, this.time, place)
    }
  },
  watch: {
    genreId: function (val) {
      if (this.genres.length > 0) {
        this.places = this.$store.getters['places/getPlacecByGenreWithDistance'](this.target.route, val)
        this.placeId = this.places[0].id

        // 宿泊施設
        this.isStay = (val == 'TH6_tag159') ? true : false
      }
    }
  }
}
</script>
